import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import React, { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';

import './ThreeDotMenu.scss';

interface IThreeDotMenuProps {
    className?: string,
    children?: React.ReactNode,
}

export const ThreeDotMenu = forwardRef<HTMLDivElement, IThreeDotMenuProps>(function ThreeDotMenu(props, ref) {
    const { children, className } = props;

    return (
        <Dropdown
            className={cn('threeDotMenu', className)}
            ref={ref}
        >
            <Dropdown.Toggle variant="success" className="threeDotMenu_toggle">
                <FontAwesomeIcon icon="ellipsis-v" />
            </Dropdown.Toggle>
            <Dropdown.Menu
                align="right"
                // Offset the menu slightly from the button
                popperConfig={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 5],
                            },
                        },
                    ],
                }}
            >
                {children}
            </Dropdown.Menu>
        </Dropdown>
    );
})
